import { render } from "./Blog.vue?vue&type=template&id=c21dcf66&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=c21dcf66&scoped=true&lang=css"
import "./Blog.vue?vue&type=style&index=1&id=c21dcf66&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21dcf66"]])

export default __exports__